import { Button, ButtonProps } from '@material-ui/core'
import React from 'react'

export const OutlinedButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  return (
    <Button
      variant='outlined'
      color='secondary'
      size='large'
      sx={{
        width: '100%',
        height: 56,
        border: 'solid 1px #dfdfdf',
        fontWeight: 'bold',
        color: 'secondary.main'
      }}
      {...props}
    >
      {children}
    </Button>
  )
}
